export class ResponseDeffers {
    constructor() {
        this._responseDeffers = {};
    }
    handleRequest(id, meta) {
        this._responseDeffers[id] = {
            resolve: meta.resolve,
            reject: meta.reject,
        };
    }
    handleResponse(id, data, error) {
        var _a, _b;
        if (error !== undefined) {
            (_a = this._responseDeffers[id]) === null || _a === void 0 ? void 0 : _a.reject(error);
        }
        else {
            (_b = this._responseDeffers[id]) === null || _b === void 0 ? void 0 : _b.resolve(data);
        }
        delete this._responseDeffers[id];
    }
}
export const responseDeffers = new ResponseDeffers();
